import {Injectable, OnInit} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {StorageService} from "../shared/services/storage.service";


@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements OnInit, CanActivate {

    constructor(private router: Router, private storageService: StorageService) {
    }

    ngOnInit() {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean {
        if (!this.storageService.isLoggedIn()) {
            this.router.navigate(["/sessions/signin"])
            return false;
        } else {
            return true;
        }
    }

}
